import { Home } from "components/pages/home/Home";
import { createBrowserRouter, Link, Outlet, Route, Routes, NavLink } from "react-router-dom";
import "./Navigation.css";
import { Fragment } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { BiSpreadsheet } from "react-icons/bi";
import { IoMdHome, IoMdPerson } from "react-icons/io";
import { FaFile } from "react-icons/fa";
import { MdPeople } from "react-icons/md";
import { PiShoppingCartSimpleFill } from "react-icons/pi";
import { HiMiniArrowPathRoundedSquare } from "react-icons/hi2";
import { useMsal, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { useEffect, useState } from "react";
import { useStores } from "core/stores";
import { observer } from "mobx-react-lite";
import { IUser } from "common/interfaces/IUser";
import { Spinner } from "components/common/Spinner";

export const Navigation = observer(() => {
    const fileStaticPath = "/e-ClaimUserGuide.docx"; // Path to the static file
    const fileName = "User-Guide.docx";
    const { accounts } = useMsal();

    const { userStore } = useStores();

    const [isAdmin, setIsAdmin] = useState<boolean>(false);

    const [currentUser, setCurrentUser] = useState<IUser | undefined>(undefined);

    const [userNotExistMessage, setUserNotExistMessage] = useState<string | undefined>(undefined);

    useEffect(() => {
        setIsAdmin(userStore.currentUser?.userType == "Application Admin" || userStore.currentUser?.userType == "IT Admin" ? true : false);
    }, [userStore.currentUser]);

    useEffect(() => {
        userStore
            .setCurrentUser()
            .then((resp) => {
                if ((userStore.currentUser?.userId as number) > 0) {
                    setCurrentUser(userStore.currentUser as IUser);
                } else {
                    setCurrentUser({ userId: 0 });
                }
            })
            .catch((error) => {});
        console.log("any route refresh brings here");
    }, []);

    useEffect(() => {
        if (currentUser?.userId == 0) {
            setUserNotExistMessage("User does not exist in the system");
        }
    }, [currentUser]);

    return (
        <Fragment>
            <ul className="unorderedListStyle">

                {userStore.currentUser && (
                    <>
                        <li className="navItem">
                            {accounts.length > 0 && (
                                <span>
                                    {" "}
                                    <IoMdPerson className="icons-size" />
                                    {accounts[0].name}{" "}
                                </span>
                            )}
                        </li>
                        <li className="navItem">
                            <NavLink className={({ isActive }) => (isActive ? "navItemActive" : "")} to="/">
                                <IoMdHome className="icons-size" />
                                Home
                            </NavLink>
                        </li>
                        <li className="navItem">
                            <NavLink className={({ isActive }) => (isActive ? "navItemActive" : "")} to="/viewclaims">
                                <BiSpreadsheet className="icons-size" />
                                View Claims
                            </NavLink>
                        </li>
                        <li className="navItem">
                            <NavLink className={({ isActive }) => (isActive ? "navItemActive" : "")} to="/newclaim">
                                <FaFile className="icons-size" />
                                New Claim
                            </NavLink>
                        </li>
                        {isAdmin && (
                            <li className="navItem">
                                <NavLink className={({ isActive }) => (isActive ? "navItemActive" : "")} to="/users">
                                    <MdPeople className="icons-size" />
                                    Users
                                </NavLink>
                            </li>
                        )}
                        {isAdmin && (
                            <li className="navItem">
                                <NavLink className={({ isActive }) => (isActive ? "navItemActive" : "")} to="/workflows">
                                    <HiMiniArrowPathRoundedSquare className="icons-size" />
                                    Workflows
                                </NavLink>
                            </li>
                        )}
                        <li className="navItem">
                            <NavLink className={({ isActive }) => (isActive ? "navItemActive" : "")} to="/myprofile">
                                <IoMdPerson className="icons-size" />
                                My Profile
                            </NavLink>
                        </li>{" "}
                        <li className="navItem">
                            <a
                                href={fileStaticPath}
                                download={fileName}
                                className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:scale-105"
                                aria-label={`Download ${fileName}`}
                            >
                                Download {fileName}
                            </a>
                        </li>{" "}
                    </>
                )}
                {!currentUser && <Spinner />}
                {currentUser?.userId == 0 && (
                    <>
                        <span className="alert-color">{userNotExistMessage}</span>
                    </>
                )}
            </ul>

            <hr />
            <Outlet />
        </Fragment>
    );
});
